module.exports = __webpack_public_path__ + "img/p3_13.9125118e.png";